import {
    LineChart,
    Line,
    ResponsiveContainer,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Label,
} from "recharts";

import {
    Box,
    Text,
} from "@chakra-ui/react";

import Card from "./Card";

const ReferralGrowthChart = ({
    drivers = [],
}) => {
    const monthlyReferrals =
        drivers.reduce(
            (
                acc,
                driver
            ) => {
                const date =
                    new Date(
                        driver.created_at
                    );

                const month =
                    date.toLocaleDateString(
                        "en-US",
                        {
                            month:
                                "short",
                        }
                    );

                acc[month] =
                    (acc[
                        month
                    ] || 0) + 1;

                return acc;
            },
            {}
        );

    const monthOrder = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    const currentMonthIndex = new Date().getMonth();

    const visibleMonths = [];

    for (let i = -2; i <= 2; i++) {
        const index = (currentMonthIndex + i + 12) % 12;
        visibleMonths.push(monthOrder[index]);
    }

    const data = visibleMonths.map((month) => ({
    month,
    referrals: monthlyReferrals[month] || 0,
}));

    return (
        <Card>
            <Box mb={6}>
                <Text
                    fontSize="lg"
                    fontWeight="700"
                    color="#071D54"
                >
                    Referral Growth
                </Text>

                <Text
                    color="gray.500"
                    fontSize="sm"
                >
                    Monthly trend of
                    recruited drivers
                    joining the platform.
                </Text>
            </Box>

            <ResponsiveContainer
                width="100%"
                height={550}
            >
                <LineChart
                    data={data}
                    margin={{
                        top: 20,
                        right: 20,
                        left: 10,
                        bottom: 20,
                    }}
                >
                    <CartesianGrid
                        strokeDasharray="3 3"
                        vertical={false}
                        stroke="#E2E8F0"
                    />

                    <XAxis
                        dataKey="month"
                        tick={{
                            fontSize: 12,
                        }}
                    >
                        <Label
                            value="Month"
                            offset={-10}
                            position="insideBottom"
                        />
                    </XAxis>

                    <YAxis
                        allowDecimals={
                            false
                        }
                        tick={{
                            fontSize: 12,
                        }}
                    >
                        <Label
                            value="Drivers"
                            angle={-90}
                            position="insideLeft"
                        />
                    </YAxis>

                    <Tooltip
                        formatter={(
                            value
                        ) => [
                            `${value} Drivers`,
                            "Recruits",
                        ]}
                    />

                    <Line
                        type="monotone"
                        dataKey="referrals"
                        name="Drivers Recruited"
                        stroke="#2453FF"
                        strokeWidth={3}
                        dot={{
                            r: 5,
                            fill: "#2453FF",
                        }}
                        activeDot={{
                            r: 7,
                        }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </Card>
    );
};

export default ReferralGrowthChart;